export function isNumber(value: unknown): boolean {
  return typeof value === "number";
}

export function isArray(value: unknown): boolean {
  return value !== null && Array.isArray(value);
}

export function isEmptyArray(value: Array<unknown>): boolean {
  return isArray(value) && value.length === 0;
}

export function isObject(value: object): boolean {
  return (
    (typeof value === "object" || typeof value === "function") &&
    !Array.isArray(value) &&
    value !== null
  );
}

export function isEmptyObject(value: object) {
  return isObject(value) && Object.keys(value).length === 0;
}

export function objectHasEmptyValue(value: object) {
  return (
    Object.values(value).filter((value) => {
      return value === "" || value === undefined || value === null;
    }).length > 0
  );
}

export function isUndefinedOrNull(value: unknown) {
  return value == null;
}

export function isUndefined(value: unknown) {
  return value === undefined;
}